/**
 * preload image
 */
export const preLoad = (url: string) => {
  const preLoadImg = new Image();
  preLoadImg.src = url;
};
